//import React, {Component} from 'react'
//import {render} from 'react-dom';
// not using webpack here maybe later

import Autosuggest from 'react-autosuggest';

const exam_list = window.exams;



function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestions(value) {
  const escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === '') {
    return [];
  }

  const regex = new RegExp('^' + escapedValue, 'i');

  return exam_list.filter(exam => regex.test(exam.code));
}

function getSuggestionValue(suggestion) {
  return suggestion.name;
}


function renderSuggestion(suggestion) {
  return (
    <span>{suggestion.name}</span>
  );
}



class Search extends React.Component {
  constructor(props){
    super();


    this.state = {
      value: '',
      suggestions: []
    };

    this.onChange = this.onChange.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
  }


  onSuggestionSelected(event, { suggestion, suggestionValue, sectionIndex, method}) {
      window.location = suggestion.url;
  }


  onChange (event, { newValue, method }) {
    this.setState({
      value: newValue
    });
  }

  onSuggestionsFetchRequested ({value}) {
    this.setState({
      suggestions: getSuggestions(value)
    });
  }

  onSuggestionsClearRequested () {
    this.setState({
      suggestions: []
    });
  }


  render() {

    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: "Enter exam code for e.g '70-410' or 'CISM'",
      value,
      onChange: this.onChange
    };

    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionSelected={this.onSuggestionSelected}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps} />
        <i className="fa fa-search fa-2x" aria-hidden="true"></i>
      </div>
    )
  }
}

ReactDOM.render(<Search/>, document.getElementById('searchapp'));



/** WEBPACK FOOTER **
 ** ./certsite/static/js/search.js
 **/